module.exports = __webpack_public_path__ + "static/media/copenhagen-silhouette.8d759fd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/copenhagen-silhouette.jpg
// module id = 517
// module chunks = 0